import { Avatar } from "@velaro/velaro-component-lib/";
import React, { useState } from "react";
const messagingClientUrl = import.meta.env.VITE_MESSAGING_CLIENT_URL as string;

interface ProfileButtonProps {
  picture: string;
  availabilityColor: string;
  label?: string;
  onToggle: () => void;
  toggleSidebar?: boolean;
}

export default function ProfileButton({
  picture,
  availabilityColor,
  label,
  onToggle,
  toggleSidebar
}: ProfileButtonProps) {
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setShowProfileMenu(!showProfileMenu);
    onToggle();
  };

  return (
    <button
      className="w-full flex items-center justify-start relative py-2"
      onClick={handleClick}
    >
      <div className="relative flex-shrink-0">
        <Avatar
          name={label}
          url={picture}
          size={toggleSidebar ? 48 : 32}
          fontSize={toggleSidebar ? 24 : 20}
        />
        {/* <img
          className={`rounded-full border ${
            toggleSidebar ? "h-12 w-12" : "h-8 w-8"
          }`}
          src={picture}
          alt="Profile"
        /> */}
        <div
          className={`absolute ${
            toggleSidebar ? "w-4 h-4" : "w-3 h-3"
          } rounded-full ${availabilityColor} right-0 bottom-0 border border-white`}
        />
      </div>
      {toggleSidebar && (
        <div className="ml-4 text-white overflow-hidden whitespace-nowrap text-ellipsis">
          {label}
        </div>
      )}
    </button>
  );
}
